var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaste(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 40,
    viewBox: "0 0 35 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.30769,10.80577V4.79333c.00105-.6325-.24399-1.22593-.68885-1.67364-.44381-.44666-1.03591-.69269-1.66587-.69374h-5.80424C15.59225,.05644,12.43615-.71333,9.95628,.7259c-.72145,.42026-1.33669,1.00419-1.79522,1.70004H2.35682C1.05904,2.42594,.00105,3.48715,0,4.79227V30.33722c0,1.30407,1.05694,2.36422,2.35682,2.36422H10.76923V14.52474c.00316-2.0485,1.66376-3.7158,3.70297-3.71897h10.83549ZM12.65385,4.11648h.0021c.70463,0,1.27779,.57548,1.27885,1.28401,0,.34212-.13251,.66523-.3744,.9081-.24084,.24286-.56265,.37697-.9055,.37697h-.00105c-.34075,0-.66046-.13305-.90234-.37485-.24189-.24286-.37545-.56703-.37545-.91126,0-.70747,.57317-1.28295,1.27779-1.28295Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.30769,20.60687V12.15841H14.47221c-1.29883,0-2.35577,1.06121-2.35577,2.36527v23.1121c0,1.30407,1.05694,2.36422,2.35577,2.36422h18.17308c1.29883,0,2.35472-1.06015,2.35472-2.36422v-15.74702h-8.41136c-.70358-.00106-1.27779-.57759-1.28095-1.28189Z",
    fill: "current"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.99895,19.5351c0-.63039-.24399-1.22382-.68885-1.67153l-4.99339-5.01354c-.44486-.44666-1.03591-.69269-1.66481-.69269h-.99805v8.37983h8.34615v-1.00102l-.00105-.00106Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaste);
export default __webpack_public_path__ + "static/media/paste.bf81e3f1165082c66b47f87421cb20c2.svg";
export { ForwardRef as ReactComponent };